import { CollectionIcon, HelpIcon, LayerIcon, ObjectIcon, RecentIcon, TemplateIcon } from 'canoe';

import { ComponentsTab } from 'craft/components/ComponentsTab';
import { HistoryTab } from 'craft/components/HistoryTab';
import { Layer } from 'craft/components/Layer';
import { ShortcutsTab } from 'craft/components/ShortcutsTab';
import { CollectionTab } from 'craft/components/Tabs';
import { TemplatesTab } from 'craft/components/TemplatesTab';
import { CraftMode } from 'craft/containers/Craft/Craft';

export interface TabItem {
  mode: CraftMode[];
  label: string;
  Component: any;
  icon: any;
  flagged?: boolean;
  tabMode: TabMode;
  placement: PalettePlacement;
}

export enum TabMode {
  FullScreen = 'FullScreen',
  Drawer = 'Drawer',
}

export enum PalettePlacement {
  Top = 'Top',
  Bottom = 'Bottom',
}

export const tabs: TabItem[] = [
  {
    mode: ['edit', 'locked'],
    label: 'Components',
    Component: ComponentsTab,
    icon: ObjectIcon,
    tabMode: TabMode.Drawer,
    placement: PalettePlacement.Top,
  },
  {
    mode: ['edit', 'locked'],
    label: 'Collections',
    Component: CollectionTab,
    icon: CollectionIcon,
    tabMode: TabMode.Drawer,
    placement: PalettePlacement.Top,
  },
  {
    mode: ['readonly', 'edit', 'locked'],
    label: 'Layers',
    Component: Layer,
    icon: LayerIcon,
    tabMode: TabMode.Drawer,
    placement: PalettePlacement.Top,
  },
  {
    mode: ['edit', 'locked'],
    label: 'Templates',
    Component: TemplatesTab,
    icon: TemplateIcon,
    tabMode: TabMode.FullScreen,
    placement: PalettePlacement.Top,
  },
  {
    mode: ['edit', 'locked'],
    label: 'History',
    Component: HistoryTab,
    icon: RecentIcon,
    tabMode: TabMode.FullScreen,
    placement: PalettePlacement.Bottom,
  },
  {
    mode: ['edit'],
    label: 'Shortcuts',
    Component: ShortcutsTab,
    icon: HelpIcon,
    tabMode: TabMode.FullScreen,
    placement: PalettePlacement.Bottom,
  },
];
